/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export interface VerificationTranslations {
    enter_code: string;
    code_sent_message: string;
    resend_code_in: string;
    code_missing: string;
    code_resent: string;
    code_resent_by_call: string;
    resend_code_sms: string;
    resend_code_call: string;
    resend_code_whatsapp: string;
    did_not_get_the_code: string;
    resend_to_try_again: string;
    continue_new_registration: string;
    login_to_existing_registration: string;
    verify_phone_number: string;
    verification_code_will_be_sent_to: string;
    get_code_via_whatsapp: string;
    get_code_via_sms: string;
}
